import React from "react";
import styles from "./SoldOut.module.css"

const SoldOut = ({label="Sold out"}) => {
    return <div className={styles.container}>{label}</div>
}

export default SoldOut